import { Circle, Moon, Sun, type LucideIcon } from "lucide-react";

/** User-selectable appearance presets (`system` kept for legacy stored values). */
export type ThemePreset = "light" | "dark" | "white" | "system";

/** Active token set applied to the document. */
export type ResolvedTheme = "light" | "dark" | "white";

export interface ThemeOption {
  id: ResolvedTheme;
  label: string;
  description: string;
  icon: LucideIcon;
  /** Preview swatches for the picker UI */
  swatch: [string, string, string];
}

/** Themes shown in the header picker and account settings. */
export const THEME_OPTIONS: ThemeOption[] = [
  {
    id: "light",
    label: "Light",
    description: "Warm cream workspace — teal sidebar & coral accents",
    icon: Sun,
    swatch: ["#f8f3eb", "#004952", "#ff8d6e"],
  },
  {
    id: "dark",
    label: "Dark",
    description: "Soft charcoal dark — easy on the eyes",
    icon: Moon,
    swatch: ["#2d2d30", "#ff8d6e", "#004952"],
  },
  {
    id: "white",
    label: "White",
    description: "Pure white surfaces — same brand colors, no cream tint",
    icon: Circle,
    swatch: ["#ffffff", "#004952", "#0f2a2d"],
  },
];

export function normalizeThemePreset(value: string | null): ThemePreset | null {
  if (value === "claude") return "white";
  if (value === "system") return "light";
  if (value === "light" || value === "dark" || value === "white") {
    return value;
  }
  return null;
}

export function getThemeOption(id: ThemePreset): ThemeOption {
  const resolved: ThemeOption["id"] = id === "system" ? "light" : id;
  return THEME_OPTIONS.find((t) => t.id === resolved) ?? THEME_OPTIONS[0]!;
}
